import { state } from "@angular/animations";
import { Inject, inject } from "@angular/core";
import { parseMarker } from "@fullcalendar/core/internal";


import { tapResponse } from "@ngrx/operators";
import { patchState, signalStore, withHooks, withMethods, withState } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { MandantService } from "@sortapp/app/api/advsortiment/services/mandant.service";
import { GraphQlEndpoint } from "@sortapp/app/graphql.service";
import { GraphQlParam } from "@sortapp/app/models/commondto/GraphQlParam";
import { VorschlagDtoClient as VorschlagDtoClient, VorschlagFlatDtoClient, VorschlagPivotDtoClient } from "@sortapp/app/models/vorschlaege/vorschlagDTOClient";
import { Apollo } from "apollo-angular";

import { ActionCRUD, SimpleResultError } from "FoxxyInterfaces";
import { CommonCheckService, EnvironmentService, LipoMessageService, SortimentDtoClient } from "FoxxyLib";
import { GraphQLEnumType, GraphQLSchema } from "graphql";
import { mergeMap, pipe, switchMap } from "rxjs";

export class VorschlaegePivotparam {
  param: MandantService.MandantQueryParams;
  userssortimente: SortimentDtoClient[];
  graphql: GraphQlParam;
}

/**Type of States */
type CockpitState = {
  vorschlagsSortimente: Array<SortimentDtoClient>,

  cockpitError: SimpleResultError,
  vorschlaegeFlat: { [key: number]: VorschlagFlatDtoClient },
  isLoading: boolean,
  cockpitSuccess: CockpitSuccess,
  activeTab: number;
};

type CockpitSuccess =
  {
    message: string;
    crud: ActionCRUD,
    data: VorschlagFlatDtoClient;
  }


export const CockpitStore = signalStore(
  { providedIn: 'root' },
  withHooks({
    onInit(store) {
    },
    onDestroy(store) {
    }
  }),

  withState(<CockpitState>{
    vorschlagsSortimente: new Array<SortimentDtoClient>(),
    vorschlaegeHits: {},
    vorschlaegeFlat: {},


    cockpitError: <SimpleResultError>null,
    isLoading: false,
    cockpitSuccess: <CockpitSuccess>null,
    activeTab: 0
  }),
  withMethods(
    (
      store,
      mandantService = inject(MandantService),
      commonvalidaService = inject(CommonCheckService),
      enVService = inject(EnvironmentService),
      apollo = inject(Apollo),

    ) => ({
      setactiveTab: (tab: number) => {
        patchState(store, { activeTab: tab });
      },
      setVorschlagsSortimente: (sortimente: SortimentDtoClient[]) => {
        patchState(store, { vorschlagsSortimente: sortimente });
      },
      vorschlagEntfernen: rxMethod<MandantService.MandantRemoveParams>(
        pipe(
          mergeMap((param) => {
            mandantService.rootUrl = enVService.environment.connections.ADVSortimentWebapi;
            return mandantService.MandantRemoveResponse(param).pipe(
              tapResponse({
                next: (result) => {
                  if (result.body.error == true) {
                    patchState(store, { cockpitError: SimpleResultError.getSimpleResultError(result.body, "Fehler Vorschlag entfernt") });
                  } else {
                    const resultobj = { ...store.vorschlaegeFlat() };
                    if (resultobj[param.sortimentId]) {
                      resultobj[param.sortimentId].pivot = resultobj[param.sortimentId].pivot.filter(d => d.catalogProductNumber != param.catalogProductNumber);
                      patchState(store, { vorschlaegeFlat: resultobj, cockpitSuccess: { message: "Vorschlag entfernt ", crud: ActionCRUD.Delete, data: resultobj[param.sortimentId] } });
                    }
                  }
                },
                error: (error) => {
                  patchState(store, { isLoading: false, cockpitError: SimpleResultError.getSimpleResultError(error, "Fehler Vorschläge entfernen") });
                },
              }),
            )
          }))),

      getVorschlaegeCockpit: rxMethod<VorschlaegePivotparam>(
        pipe(
          mergeMap((param) => {
            patchState(store, { cockpitError: null, isLoading: true });
            return apollo.use(GraphQlEndpoint.Default)
              .query<any>({
                query: param.graphql.query,
                variables: param.graphql.variables,
              }).pipe(tapResponse({
                next: (result) => {
                  patchState(store, { cockpitError: null, isLoading: false });

                  const resultobj = { ...store.vorschlaegeFlat() };
                  param.userssortimente.forEach(sortiment => {
                    resultobj[sortiment.id] = new VorschlagFlatDtoClient(result.data["vorschlagArtikel"].items, sortiment, commonvalidaService);
                  })
                  patchState(store, { vorschlaegeFlat: resultobj });


                }
                ,
                error: (error) => {
                  patchState(store, { cockpitError: SimpleResultError.getSimpleResultError(error, "Fehler Vorschläge Sortimentieren laden") });
                }
              }
              )
              )
          })),




      ),

      getVorschlaegeUebersicht: rxMethod<VorschlaegePivotparam>(
        pipe(
          mergeMap((param) => {
            mandantService.rootUrl = enVService.environment.connections.ADVSortimentWebapi;
            patchState(store, { cockpitError: null, isLoading: true });
            return mandantService.MandantQueryResponse(param.param).pipe(
              tapResponse({
                next: (r) => {
                  patchState(store, { cockpitError: null, isLoading: false });
                  try {
                    const resultobj = { ...store.vorschlaegeFlat() };
                    param.userssortimente.forEach(sortiment => {
                      resultobj[sortiment.id] = new VorschlagFlatDtoClient(r.body.result, sortiment, commonvalidaService);
                    })
                    patchState(store, { vorschlaegeFlat: resultobj });
                  } catch (e) {
                    patchState(store, { cockpitError: SimpleResultError.getSimpleResultError(e, "Fehler Vorschläge laden") });
                  }
                },
                error: (error) => {

                  patchState(store, { isLoading: false, cockpitError: SimpleResultError.getSimpleResultError(error, "Vorschläge laden") });
                },
              }),
            )
          })))

    })
  )
)


//for Constructor injection
export type CockpitStore = InstanceType<typeof CockpitStore>;
